module.exports = __webpack_public_path__ + "img/logo_dark.b9c2552c.png";